//  doShowJson,JkOpenwinParams,
import { Location } from '@angular/common';
import {
  ChangeDetectorRef,
  inject,
  Injectable,
  Injector,
  ApplicationRef,
  Optional,
} from '@angular/core';
import { Router, ActivatedRoute, provideRouter } from '@angular/router';
import { DomSanitizer, Meta, SafeUrl, Title } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import Swal from 'sweetalert2';
import {
  SweetAlertOptions,
  SweetAlertIcon,
  SweetAlertPosition,
  SweetAlertResult,
} from 'sweetalert2';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { jkLibClass } from './jkCommon';
import { Preference } from './preference';
import { AppPage, jkRestReturnClass } from './jkClass';
import { jkRestReturn, idNameItem, JkOpenwinParams } from './jkInterface';
import { login, LoginService } from './jkUser';
import { IBasePage } from './base-page-type';
import { jkGlb } from './jkglb';
import { JkpowerService } from './jkpower.service';



//@Injectable({providedIn: 'root'})
export class BasePage extends jkLibClass implements IBasePage {
  _programId: string = '';
  get programId(): string {
    return this._programId.toLocaleLowerCase();
  }
  set programId(value: string) {
    this._programId = value.toLocaleLowerCase();
  }
  public icon?: string;
  public url: string = '';
  public isErrorViewVisible: boolean = false;
  public isEmptyViewVisible: boolean = false;
  public isContentViewVisible: boolean = false;
  public isLoadingViewVisible: boolean = false;
  public isAuthViewVisible: boolean = false;

  public preference: Preference;
  protected activatedRoute: ActivatedRoute;
  public dialog: MatDialog;
  public router: Router;
  public location: Location;
  public sanitizer: DomSanitizer;
  public snackBar: MatSnackBar;
  public _title: Title;
  public platform: Platform;
  public cdr: ChangeDetectorRef; // 只用於 markForCheck(). 不要 在這裡呼叫 cdr.detectChanges()
  //protected translate: TranslateService;
  //protected sanitizer: DomSanitizer;
  protected _label: string = '';

  //screenWidth: number = window.innerWidth - 40;
  get screenWidth(): number {
    return window.innerWidth - 40;
  }
  //screenHeight: number = window.innerHeight;
  get screenHeight(): number {
    return window.innerHeight;
  }
  ret: jkRestReturn; // jkRestReturnClass;
  lstCompany: idNameItem[] = [];
  companySelected: string = '';
  login: LoginService; // = inject(LoginService);
  appRef: ApplicationRef;
  protected injector: Injector;
  constructor(injector: Injector) {
    super();

    this.injector = injector;
    this.preference = injector.get(Preference);
    this.activatedRoute = injector.get(ActivatedRoute);
    this.dialog = injector.get(MatDialog);
    this.router = injector.get(Router);
    this.location = injector.get(Location);
    this.sanitizer = injector.get(DomSanitizer);
    this.snackBar = injector.get(MatSnackBar);
    this._title = injector.get(Title);
    this.platform = injector.get(Platform);
    this.cdr = injector.get(ChangeDetectorRef);
    this.appRef = injector.get(ApplicationRef);
    this.login = login;
    this.ret = new jkRestReturnClass();
  }
  get host() {
    return this.login.hostName;
  }
  public get isLogin(): boolean {
    if (this.login) return this.login.isLogin;
    else return false;
  }
  public get serverUrl(): string {
    if (!this.login) return '';
    return this.login.hostName;
  }
  public get uid(): string {
    if (!this.login) return '';
    return this.login.userid;
  }
  public get userName(): string {
    if (!this.login) return '';
    return this.login.name;
  }
  public get title(): string {
    if (!this._title) return '';
    return this._title.getTitle();
  }
  /*
  init(environment: any){
    this.environment = environment;
  }
  environment: any = undefined;
  public get appId(): string {
    if(!this.environment) return '';
    return this.environment.appId;
  }

  public get stripePublicKey(): string {

    return environment.stripePublicKey;
  }

  public get appName(): string {
    return environment.appName;
  }
  public get appDescript(): string {
    return environment.appDescript;
  }*/
  public set title(title1: string) {
    this._title.setTitle(title1);
  }
  // 以下CALL sweetAlert ================================================================================================
  async showInput(
    title: string,
    label: string,
    inputValue: string,
    inuptType: 'text' | 'email' | 'url' | 'password' | 'textarea' = 'text',
  ): Promise<any> {
    let { value: data } = await Swal.fire({
      // return { value: ipAddress }
      title: title,
      input: inuptType,
      inputLabel: label,
      inputValue,
      showCancelButton: true,
      // inputValidator: (value:any) => {
      //   return value;
      // },
    });
    return data;
  }
  async showSelectItems(
    title: string,
    label: string,
    kind: 'select' | 'radio' = 'select',
    opt: any,
  ): Promise<any> {
    let { value: data } = await Swal.fire({
      // return { value: ipAddress }
      title: title,
      input: kind,
      inputLabel: label,
      inputOptions: opt, //
      showCancelButton: true,
      // inputValidator: (value:any) => {
      //   return value;
      // },
    });
    return data;
  }
  /*
  async showMessageMat(msg:string,action:string='確定',type:string='success'){
    this.snackBar.open(msg, action);
  }
  confirmMat(msg: string, action: string = '確定', type: string = 'success'): Promise<boolean> {
    return new Promise((resolve) => {
        let snackBarRef = this.snackBar.open(msg, action,{
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
        snackBarRef.onAction().subscribe(() => {
            resolve(true);
        });
        snackBarRef.afterDismissed().subscribe(() => {
            resolve(false);
        });
    });
  }*/
  async showMessage(msg = '', type: SweetAlertIcon = 'success') {
    const toast = Swal.mixin({
      toast: true,
      //position: 'top',
      showConfirmButton: true,
      timer: 5000,
      customClass: { container: 'toast' },
    });
    await toast.fire({
      title: msg,
      icon: type, // SweetAlertIcon.success,
      padding: '10px 20px',
    });
  }

  // TODO: 未完成
  async showSteps(title: string, text: string, steps = ['1', '2', '3']) {
    //const steps = ['1', '2', '3'];
    const swalQueueStep = Swal.mixin({
      confirmButtonText: 'Next →',
      showCancelButton: true,
      progressSteps: steps,
      input: 'text',
      inputAttributes: {
        required: 'true',
      },
      validationMessage: 'This field is required',
      padding: '2em',
      //customClass: 'sweet-alerts', ?
    });

    const values: any = [];
    let currentStep;
    for (currentStep = 0; currentStep < steps.length; ) {
      let options: SweetAlertOptions = {
        title: `Question ${steps[currentStep]}`,
        text: currentStep == 0 ? 'Chaining swal modals is easy.' : '',
        inputValue: values[currentStep] || '',
        showCancelButton: currentStep > 0,
        currentProgressStep: currentStep,
        //customClass: 'sweet-alerts',
      };

      const result = await swalQueueStep.fire(options);

      /*const result = await swalQueueStep.fire({
        title: `Question ${steps[currentStep]}`,
        text: currentStep == 0 ? 'Chaining swal modals is easy.' : '',
        inputValue: values[currentStep] || '',
        showCancelButton: currentStep > 0,
        currentProgressStep: currentStep,
        customClass: 'sweet-alerts',
      });*/
      if (result.value) {
        values[currentStep] = result.value;
        currentStep++;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        currentStep--;
      } else {
        break;
      }
    }

    if (currentStep === steps.length) {
      await Swal.fire({
        title: 'All done!',
        padding: '2em',
        html: 'Your answers: <pre>' + JSON.stringify(values) + '</pre>',
        confirmButtonText: 'Lovely!',
        //customClass: 'sweet-alerts',
      });
    }
  }
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  showAlertMat(
    message: string,
    icon: SweetAlertIcon = 'error',
    title: string = '',
  ) {
    this.snackBar.open(message, '確定', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }
  async showAlert(
    message: string,
    icon: SweetAlertIcon = 'error',
    title: string = '',
  ) {
    //await Swal.mixin
    await Swal.fire({
      title: '警告:' + title,
      text: message,
      icon: icon, // 'success' | 'error' | 'warning' | 'info' | 'question'
      padding: '1em',
      //customClass: 'sweet-alerts',
    });
  }
  async showMessageWithTimer(
    title: string,
    html: string,
    timer: number = 2000,
  ) {
    let timerInterval: any;
    //const cdr = inject(ChangeDetectorRef);

    await Swal.fire({
      title: title, // 'Auto close alert!'
      html: html, //'I will close in <b></b> milliseconds.',
      timer: timer,
      timerProgressBar: true,
      //customClass: 'sweet-alerts',
      didOpen: () => {
        Swal.showLoading();
        let container = Swal.getHtmlContainer();
        if (container) {
          const b: any = container.querySelector('b');
          if (b) {
            timerInterval = setInterval(() => {
              b.textContent = String(Swal.getTimerLeft());
              // 手動觸發變更檢測以符合 zoneless 模式
              //this.cdr.markForCheck();
              this.appRef.tick();  // 不用 cdr 了
            }, 100);
          }
        } // if container
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        //console.log('I was closed by the timer');
      }
    });
  }
  async showMessageWithImage(title: string, html: string, imageUrl: string) {
    await Swal.fire({
      title: title,
      //text: 'Modal with a custom image.',
      html: html,
      imageUrl: imageUrl, // '/assets/images/thumbs-up.jpg'
      imageWidth: 224,
      imageHeight: 200,
      imageAlt: 'Custom image',
      animation: false,
      padding: '2em',
      //customClass: 'sweet-alerts',
    });
  }
  async showConfirm(
    title: string,
    text: string,
  ): Promise<SweetAlertResult<any>> {
    return await Swal.fire({
      topLayer: typeof document !== 'undefined' && 'showPopover' in document.documentElement,
      icon: 'question',
      title: title,
      text: text,
      showCancelButton: true,
      confirmButtonText: '確認',
      cancelButtonText: '取消',
      padding: '2em',
      //customClass: 'sweet-alerts',
    });
    /*.then((result) => {
        if (result.value) {
            Swal.fire({ title: 'Deleted!', text: 'Your file has been deleted.', icon: 'success', customClass: 'sweet-alerts' });
        }
    });*/
  }
  async confirm(title: string, text: string): Promise<boolean> {
    let result: boolean = false;
    let r = await Swal.fire({
      icon: 'question',
      title: title,
      text: text,
      showCancelButton: true,
      confirmButtonText: '確認',
      cancelButtonText: '取消',
      padding: '2em',
      //customClass: 'sweet-alerts',
    }); /*.then((result) => {
        if (result.value) {
            //Swal.fire({ title: 'Deleted!', text: 'Your file has been deleted.', icon: 'success', customClass: 'sweet-alerts' });
            result = true;
        }
    });*/
    if (r.value) result = true;
    return result;
  }
  async showToast(
    message: string,
    duration: number = 3000,
    position: SweetAlertPosition = 'bottom',
    icon: SweetAlertIcon = 'success',
    color = 'primary',
  ) {
    const toast = Swal.mixin({
      toast: true,
      position: position, //'top-end',
      showConfirmButton: false,
      timer: duration,
      padding: '2em',
      //customClass: 'sweet-alerts',
    });
    await toast.fire({
      icon: icon,
      title: message,
      padding: '2em',
      //customClass: 'sweet-alerts',
      customClass: {
        popup: `color-${color}`, // 'color-primary',color-danger color-warning color-success color-info color-secondary
      },
    });
  }
  async showLoadingView(params: { showOverlay: boolean }) {
    if (params.showOverlay) {
      const loadingText = '載入中...'; //await this.getTrans('LOADING');
      Swal.showLoading();
    } else {
      this.isAuthViewVisible = false;
      this.isErrorViewVisible = false;
      this.isEmptyViewVisible = false;
      this.isContentViewVisible = false;
      this.isLoadingViewVisible = true;
    }

    return true;
  }

  async dismissLoadingView() {
    this.isLoadingViewVisible = false;
    Swal.close();
  }
  showContentView() {
    this.isAuthViewVisible = false;
    this.isErrorViewVisible = false;
    this.isEmptyViewVisible = false;
    this.isLoadingViewVisible = false;
    this.isContentViewVisible = true;

    this.dismissLoadingView();
  }

  showEmptyView() {
    this.isAuthViewVisible = false;
    this.isErrorViewVisible = false;
    this.isLoadingViewVisible = false;
    this.isContentViewVisible = false;
    this.isEmptyViewVisible = true;

    this.dismissLoadingView();
  }

  showErrorView() {
    this.isAuthViewVisible = false;
    this.isLoadingViewVisible = false;
    this.isContentViewVisible = false;
    this.isEmptyViewVisible = false;
    this.isErrorViewVisible = true;

    this.dismissLoadingView();
  }

  showAuthView() {
    this.isLoadingViewVisible = false;
    this.isContentViewVisible = false;
    this.isEmptyViewVisible = false;
    this.isErrorViewVisible = false;
    this.isAuthViewVisible = true;

    this.dismissLoadingView();
  }

  onRefreshComplete(data: any[]) {
    alert('onRefreshComplete 程式碼未完成');
  }

  isDesktop(): boolean {
    //return this.platform.is('desktop');
    return this.platform.isBrowser;
  }
  isIos(): boolean {
    return this.platform.IOS; //this.platform.is('ios');
  }

  isAndroid(): boolean {
    return this.platform.ANDROID; //is('android');
  }
  isBrowser(): boolean {
    return this.platform.isBrowser;
  }

  goBack() {
    // this.navCtrl.back();
    if (this.location) this.location.back();
    else if (this.router) this.router.navigate(['/']);
    else this.navigateTo('/');
  }
  async goHome() {
    await this.goRoot();
  }
  async goRoot(): Promise<boolean> {
    return await this.navigateTo('/');
  }
  private findAppPageByRoute(appPages: AppPage[], page: string): AppPage | undefined {
    const normalizedPage = this.normalizeRoute(page);
    for (const appPage of appPages) {
      if (
        appPage.id.toLocaleLowerCase() === normalizedPage.replace('/', '').toLocaleLowerCase() ||
        this.normalizeRoute(appPage.url || '') === normalizedPage
      ) {
        return appPage;
      }
      const childPage = this.findAppPageByRoute(appPage.items || [], page);
      if (childPage) return childPage;
    }
    return undefined;
  }

  private normalizeRoute(page: string): string {
    if (!page) return '';
    const purePath = page.split('?')[0].split('#')[0];
    return purePath.startsWith('/') ? purePath : '/' + purePath;
  }

  private async canNavigateTo(page: string): Promise<boolean> {
    const myAppPage = this.findAppPageByRoute(jkGlb.pages, page);
    if (!myAppPage) return true;

    const power = this.injector.get(JkpowerService);
    const isPower = await power.setPower(
      myAppPage.id,
      this.login,
      this.ret,
      myAppPage.isCheckPower
    );
    if (!isPower) {
      await this.showAlert('無權限進入此頁!');
      return false;
    }
    return true;
  }

  async navigateTo(page: string, queryParams: any = {}) {
    if (!(await this.canNavigateTo(page))) return false;
    if (this.router) return this.router.navigate([page], { queryParams });
    else {
      alert('無法導向:' + page + ' router 不存在');
      return false;
    }
  }

  navigateToRelative(page: string, queryParams: any = {}) {
    return this.router.navigate([page], {
      queryParams,
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
    });
  }
  getParams() {
    return this.activatedRoute.snapshot.params;
  }

  getQueryParams() {
    return this.activatedRoute.snapshot.queryParams;
  }
  getQueryParam(key: string, defaultValue: string = ''): string {
    // this.router.parseUrl(this.router.url).queryParams['stockNo']||'0050';
    return this.activatedRoute.snapshot.queryParams[key] || defaultValue;
  }
  openSimpleUrl(url: string) {
    window.open(url, '_blank');
  }
  scrollToSection(id: string) {
    // Get a reference to the element with the id of the section you want to scroll to
    const section = document.getElementById(id);
    if (!section) {
      alert('找不到該區塊:' + section);
      return;
    }
    // Use the scrollIntoView() method to scroll to the top of the section
    section.scrollIntoView();
  }
  initConfig_component(
    // 20250223 jackie 搬到page.service.ts
    param: any,
    disableClose: boolean = true,
    height: string = '95%',
    width: string = '95%',
    dialogClass: string = 'jk-dialog-resize', //'jk-dialog-resize' 'mat-dialog-container'
  ): MatDialogConfig {
    let dialRet: jkRestReturn = new jkRestReturnClass();
    //if(!dialogClass)
    // dialogClass = 'resize: both;overflow: auto;';
    dialRet.obj = param;
    let dialConf: MatDialogConfig = {
      data: dialRet,
      hasBackdrop: true,
      //maxHeight: '90vh',
      maxWidth: '100vw',
      height: height,
      width: width,
      disableClose: disableClose,
      panelClass: dialogClass, //dialogClass   // 預設就會顯示不出來!
    };
    return dialConf;
  }

  initConfig(
    form: any,
    disableClose: boolean = true,
    height: string = '95%',
    width: string = '95%',
    dialogClass: string = 'mat-dialog-container', //   custDialogClass: string ='custom-dialog-container' // 自定义样式类
  ): MatDialogConfig {
    let dialRet: jkRestReturn = new jkRestReturnClass();
    dialRet.obj = form;
    let dialConf: MatDialogConfig = {
      data: dialRet,
      hasBackdrop: true,
      //maxHeight: '90vh',
      //maxWidth: '90vw',
      maxWidth: '100vw',
      height: height,
      width: width,
      disableClose: disableClose,
      panelClass: dialogClass, // 預設就會顯示不出來!
    };
    return dialConf;
  }
}
